var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSideArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 17C14 16.7 14.1 16.5 14.3 16.3L19.3 11.3C19.7 10.9 20.3 10.9 20.7 11.3C21.1 11.7 21.1 12.3 20.7 12.7L15.7 17.7C15.3 18.1 14.7 18.1 14.3 17.7C14.1 17.5 14 17.3 14 17Z",
    fill: "#3565FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7C14 6.7 14.1 6.5 14.3 6.3C14.7 5.9 15.3 5.9 15.7 6.3L20.7 11.3C21.1 11.7 21.1 12.3 20.7 12.7C20.3 13.1 19.7 13.1 19.3 12.7L14.3 7.7C14.1 7.5 14 7.3 14 7Z",
    fill: "#3565FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12C3 11.4 3.4 11 4 11L20 11C20.6 11 21 11.4 21 12C21 12.6 20.6 13 20 13H4C3.4 13 3 12.6 3 12Z",
    fill: "#3565FC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideArrow);
export default __webpack_public_path__ + "static/media/sideArrow.cf0afe0bd118d93f9576421e8c245115.svg";
export { ForwardRef as ReactComponent };